import React, { useState, useEffect } from "react";
import {
  getAllResource,
  sendToGroupResoruce,
  deleteResource,
} from "../../services/postService";
import { fetchResourceById } from "../../services/userServices";
import { Link } from "react-router-dom";
import parse, { domToReact } from "html-react-parser";
// parseHtml removed - not used
import DashboardStatusGrid from "./DashboardStatusGrid";
import { getCategories } from "../../services/productServices";
import Spinner from "../shared/Spinner";

function sanitizeHtmlForTelegram(html, bulletEmoji = "🔹") {
  // … (sanitizeHtmlForTelegram unchanged) …
}

function PreViewResource() {
  const [categories, setCategories] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tab, setTab] = useState("posted");
  const [selectedPosts, setSelectedPosts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [sendingToGroup, setSendingToGroup] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewPost, setPreviewPost] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [toast, setToast] = useState({ message: "", isError: false });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 15,
    totalItems: 0,
    totalPages: 0,
  });

  const tabs = [
    { id: "posted", label: "Posted" },
    { id: "notPosted", label: "Not Posted" },
  ];
  const tabWidth = 150;
  const currentIndex = tabs.findIndex((t) => t.id === tab);

  // Fetch all posts/resources on mount
  const fetchPosts = async (page = 1) => {
    setLoading(true);
    setError("");
    try {
      const isPosted = tab === "posted";
      const response = await getAllResource(isPosted, page);
      console.log("Response from getAllResource:", response);
      setPosts(response.resources || []);
      setPagination({
        currentPage: response.pagination.currentPage,
        pageSize: response.pagination.pageSize,
        totalItems: response.pagination.totalItems,
        totalPages: response.pagination.totalPages,
      });
    } catch (err) {
      console.error("Error fetching resources:", err);
      setError("No resources found");
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts(1); // fetch first page when tab changes
  }, [tab]);

  // Refresh toast auto‐dismiss
  useEffect(() => {
    if (!toast.message) return;
    const timer = setTimeout(
      () => setToast({ message: "", isError: false }),
      3000
    );
    return () => clearTimeout(timer);
  }, [toast]);

  useEffect(() => {
    (async () => {
      try {
        const cats = await getCategories();
        setCategories(cats);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    })();
  }, []);

  // Filter by posted vs. not posted
  const filteredPosts = posts.filter((post) =>
    tab === "posted" ? post.is_posted : !post.is_posted
  );

  // Sort newest first
  const sortedPosts = [...filteredPosts].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const handleCheckboxChange = (post) => {
    setSelectedPosts((prev) =>
      prev.some((p) => p.id === post.id)
        ? prev.filter((p) => p.id !== post.id)
        : [...prev, post]
    );
  };

  const handlePageChange = (newPage) => {
    fetchPosts(newPage);
  };

  const areAllSameType = () =>
    selectedPosts.length > 0 &&
    selectedPosts.every((p) => p.type === selectedPosts[0].type);

  const handleSendToGroupResoruce = async () => {
    try {
      const uniqueTopicIds = Array.from(new Set(selectedTopics));

      setSendingToGroup(true);
      await sendToGroupResoruce(
        selectedPosts.map((p) => p.id),
        message,
        uniqueTopicIds.length ? uniqueTopicIds : null
      );
      setToast({
        message: "Resource sent to group successfully!",
        isError: false,
      });
      setShowModal(false);
      setSelectedPosts([]);
      setMessage("");
      setShowModal(false);

      fetchPosts(1);
    } catch (err) {
      setToast({ message: err.message, isError: true });
    } finally {
      setSendingToGroup(false);
    }
  };

  const handleViewPost = async (postId) => {
    try {
      setLoadingPreview(true);
      setShowPreviewModal(true);
      const { post } = await fetchResourceById(postId);
      setPreviewPost(post);
    } catch (err) {
      setToast({ message: err.message, isError: true });
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleDelete = async (postId) => {
    if (!window.confirm("Are you sure you want to delete this post?")) return;
    try {
      await deleteResource(postId);
      setToast({ message: "Post deleted successfully!", isError: false });
     await fetchPosts(1);
    } catch (err) {
      setToast({ message: err.message, isError: true });
    }
  };

  // Helpers to parse body into blocks, extract image/snippet
  const parseBody = (body) => {
    if (typeof body !== "string") return body;
    try {
      let parsed = JSON.parse(body);
      if (typeof parsed === "string") parsed = JSON.parse(parsed);
      return parsed.map((blk) => {
        if (blk.type === "link" && typeof blk.content === "object") {
          const urlObj = blk.content.url || {};
          return {
            ...blk,
            url:
              typeof blk.content.url === "string"
                ? blk.content.url
                : urlObj.url,
            displayText:
              blk.content.displayText || urlObj.displayText || urlObj.url || "",
          };
        }
        return blk;
      });
    } catch {
      return [{ type: "paragraph", text: body }];
    }
  };

  const getFirstImageUrl = (blocks) => {
    if (!Array.isArray(blocks)) return null;
    const img = blocks.find((b) => b.type === "image" && b.url);
    return img?.url || null;
  };

  const getSnippetFromBlocks = (blocks, maxLength = 120) => {
    if (!Array.isArray(blocks)) return "";
    const text = blocks
      .filter((b) => b.type === "paragraph" && b.text)
      .map((b) =>
        typeof b.text === "string" ? b.text.replace(/<[^>]+>/g, "") : ""
      )
      .join(" ")
      .trim();
    return text.length > maxLength ? text.slice(0, maxLength) + "…" : text;
  };

  const parseOptions = {
    replace: (domNode) => {
      if (domNode.type === "tag") {
        const tagName = domNode.name;
        const styles = {
          h1: "text-4xl font-extrabold my-4",
          h2: "text-3xl font-bold my-4",
          h3: "text-2xl font-semibold my-3",
          h4: "text-xl font-semibold my-3",
          h5: "text-lg font-medium my-2",
          h6: "text-base font-medium my-1",
          ul: "list-disc list-inside pl-4 my-2 space-y-1",
          ol: "list-decimal list-inside pl-4 my-2 space-y-1",
        };
        if (styles[tagName]) {
          return React.createElement(
            tagName,
            { className: styles[tagName] },
            domToReact(domNode.children)
          );
        }
      }
    },
  };

  return (
    <div className="bg-gray">
      <DashboardStatusGrid />

      <div className="container mx-auto max-w-7xl py-10 bg-gray px-4">
        {/* Send button only on Not Posted tab */}
        <div className="flex justify-end mb-4">
          {tab === "notPosted" && selectedPosts.length > 0 && (
            <button
              onClick={() => setShowModal(true)}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Send to Group ({selectedPosts.length})
            </button>
          )}
        </div>

        {/* Toast */}
        {toast.message && (
          <div
            className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded shadow z-50 ${
              toast.isError
                ? "bg-red-100 border-red-400 text-red-700"
                : "bg-green-100 border-green-400 text-green-700"
            }`}
          >
            {toast.message}
            <button
              onClick={() => setToast({ message: "", isError: false })}
              className="ml-4 font-bold"
            >
              ×
            </button>
          </div>
        )}

        {/* Posted / Not Posted Tabs */}
        <div className="mb-6 flex justify-center">
          <div className="relative inline-flex rounded-full bg-transparent p-1">
            <span
              className="absolute top-0 left-0 h-full rounded-full bg-green-500 transition-transform duration-300 ease-in-out"
              style={{
                width: `${tabWidth}px`,
                transform: `translateX(${currentIndex * tabWidth}px)`,
              }}
            />
            {tabs.map(({ id, label }) => (
              <button
                key={id}
                onClick={() => setTab(id)}
                style={{ width: `${tabWidth}px` }}
                className={`relative z-10 py-2 text-center font-bold ${
                  tab === id ? "text-white" : "text-gray-700"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Posts Grid */}
        {loading ? (
          <div className="relative min-h-[calc(100vh-8rem)]">
            <Spinner size="xl" fullScreen={true} />
          </div>
        ) : error ? (
          <p className="text-red-500 text-center">{error}</p>
        ) : (
          <div className="grid gap-6">
            {sortedPosts.map((post) => {
              const blocks = parseBody(post.body);
              const imgUrl = getFirstImageUrl(blocks);
              const snippet = getSnippetFromBlocks(blocks);

              return (
                <div
                  key={post.id}
                  className="flex items-center h-52 border-b-2 py-3"
                >
                  {/* Image */}
                  <div className="w-1/3 h-full">
                    {imgUrl ? (
                      <img
                        src={imgUrl}
                        alt={post.title}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full bg-gray-400 flex items-center justify-center text-white">
                        No Image
                      </div>
                    )}
                  </div>

                  {/* Content */}
                  <div className="flex-1 p-4 flex flex-col justify-between">
                    <div>
                      <h2 className="text-xl font-semibold mb-2 truncate">
                        {post.title}
                      </h2>
                      <p className="text-gray-500 text-sm mb-2">{snippet}</p>
                      <p className="text-gray-600 text-sm">
                        Source: {post.source}
                      </p>
                    </div>

                    <div className="flex justify-end space-x-2">
                      <button
                        onClick={() => handleViewPost(post.id)}
                        className="px-10 py-2 bg-green-500 text-white rounded hover:bg-blue-600 text-sm"
                      >
                        View
                      </button>
                      <Link
                        to={`/ankuaru/editPost/${post.id}_${post.type}`}
                        className="px-10 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() => handleDelete(post.id)}
                        className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                      >
                        Delete
                      </button>
                    </div>
                  </div>

                  {/* Checkbox on Not Posted */}
                  {tab === "notPosted" && (
                    <div className="flex-shrink-0 px-2">
                      <label className="inline-flex items-center">
                        <input
                          type="checkbox"
                          checked={selectedPosts.some((p) => p.id === post.id)}
                          onChange={() => handleCheckboxChange(post)}
                          className="w-5 h-5"
                        />
                      </label>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
        {/* Pagination */}
        {!loading && !error && pagination.totalPages > 1 && (
          <div className="flex justify-center mt-8 mb-4">
            <div className="flex items-center space-x-2">
              <button
                onClick={() => handlePageChange(1)}
                disabled={pagination.currentPage === 1}
                className={`px-3 py-1 rounded ${
                  pagination.currentPage === 1
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
              >
                &laquo;
              </button>
              <button
                onClick={() => handlePageChange(pagination.currentPage - 1)}
                disabled={pagination.currentPage === 1}
                className={`px-3 py-1 rounded ${
                  pagination.currentPage === 1
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
              >
                &lt;
              </button>

              {/* Page numbers */}
              {Array.from(
                { length: Math.min(5, pagination.totalPages) },
                (_, i) => {
                  let pageNum;
                  if (pagination.totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (pagination.currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (
                    pagination.currentPage >=
                    pagination.totalPages - 2
                  ) {
                    pageNum = pagination.totalPages - 4 + i;
                  } else {
                    pageNum = pagination.currentPage - 2 + i;
                  }

                  return (
                    <button
                      key={pageNum}
                      onClick={() => handlePageChange(pageNum)}
                      className={`px-3 py-1 rounded ${
                        pagination.currentPage === pageNum
                          ? "bg-green-500 text-white"
                          : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      {pageNum}
                    </button>
                  );
                }
              )}

              <button
                onClick={() => handlePageChange(pagination.currentPage + 1)}
                disabled={pagination.currentPage === pagination.totalPages}
                className={`px-3 py-1 rounded ${
                  pagination.currentPage === pagination.totalPages
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
              >
                &gt;
              </button>
              <button
                onClick={() => handlePageChange(pagination.totalPages)}
                disabled={pagination.currentPage === pagination.totalPages}
                className={`px-3 py-1 rounded ${
                  pagination.currentPage === pagination.totalPages
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
              >
                &raquo;
              </button>

              <span className="ml-4 text-gray-600">
                Page {pagination.currentPage} of {pagination.totalPages} (
                {pagination.totalItems} items)
              </span>
            </div>
          </div>
        )}

        {/* Send to Group Modal */}
        {showModal && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
            onClick={() => {
              setShowPreviewModal(false);
              setPreviewPost(null);
            }}
          >
            {" "}
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
              <h2 className="text-2xl font-bold mb-4">Send Posts to Group</h2>

              {!areAllSameType() && (
                <div className="mb-4 p-4 bg-yellow-100 text-yellow-800 rounded">
                  Warning: Selected posts must be of the same type.
                </div>
              )}

              <div className="mb-4">
                <h3 className="font-semibold mb-2">Selected Posts:</h3>
                <div className="space-y-2">
                  {selectedPosts.map((p) => (
                    <div
                      key={p.id}
                      className="flex items-center justify-between bg-gray-50 p-2 rounded"
                    >
                      <span className="font-medium">{p.title}</span>
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleViewPost(p.id)}
                          className="text-blue-500 hover:text-blue-700"
                        >
                          View
                        </button>
                        <button
                          onClick={() =>
                            setSelectedPosts((prev) =>
                              prev.filter((x) => x.id !== p.id)
                            )
                          }
                          className="text-red-500 hover:text-red-700"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Topics */}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                  Choose Topics
                </label>
                <div className="grid grid-cols-2 gap-2">
                  {categories.map((cat) => (
                    <label key={cat.id} className="inline-flex items-center">
                      <input
                        type="checkbox"
                        checked={selectedTopics.includes(cat.topic_id)}
                        onChange={() => {
                          setSelectedTopics((prev) => {
                            if (prev.includes(cat.topic_id)) {
                              return prev.filter((x) => x !== cat.topic_id);
                            } else {
                              return [...prev, cat.topic_id];
                            }
                          });
                        }}
                        className="form-checkbox h-4 w-4"
                      />
                      <span className="ml-2">{cat.name}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                  Message (Optional)
                </label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full p-2 border rounded-md"
                  rows="4"
                  placeholder="Enter message..."
                />
              </div>

              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 border rounded hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSendToGroupResoruce}
                  disabled={
                    !areAllSameType() ||
                    sendingToGroup ||
                    selectedPosts.length === 0
                  }
                  className={`px-4 py-2 rounded text-white ${
                    !areAllSameType() ||
                    sendingToGroup ||
                    selectedPosts.length === 0
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  }`}
                >
                  {sendingToGroup ? "Sending..." : "Send to Group"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Preview Modal */}
        {showPreviewModal && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
            onClick={() => {
              setShowPreviewModal(false);
              setPreviewPost(null);
            }}
          >
            <div
              className="bg-white rounded-lg p-6 max-w-3xl w-full max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              {loadingPreview ? (
                <div className="flex items-center justify-center h-40">
                  <Spinner size="lg" />
                </div>
              ) : previewPost ? (
                <>
                  <div className="flex justify-between items-start mb-6">
                    <h2 className="text-3xl font-bold">{previewPost.title}</h2>
                    <button
                      onClick={() => {
                        setShowPreviewModal(false);
                        setPreviewPost(null);
                      }}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      &#10005;
                    </button>
                  </div>

                  <div className="mb-4 text-sm text-gray-500">
                    <p>Source: {previewPost.source}</p>
                    <p>
                      Posted on:{" "}
                      {new Date(previewPost.createdAt).toLocaleDateString()}
                    </p>
                  </div>

                  <div className="prose max-w-none space-y-4">
                    {parseBody(previewPost.body).map((block, i) => {
                      switch (block.type) {
                        case "paragraph":
                          return (
                            <div key={i} className="text-justify">
                              {typeof block.text === "string"
                                ? parse(block.text, parseOptions)
                                : null}
                            </div>
                          );
                        case "link":
                          return (
                            <div key={i} className="my-6">
                              <a
                                href={block.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                              >
                                {block.url.displayText || block.url.url}
                              </a>
                            </div>
                          );
                        case "image":
                          return (
                            <div key={i} className="mb-6">
                              <img
                                src={block.url}
                                alt={block.alt || ""}
                                className="w-full rounded-lg shadow-lg"
                              />
                            </div>
                          );
                        case "quote":
                          return (
                            <blockquote
                              key={i}
                              className="border-l-4 pl-4 italic text-gray-700"
                            >
                              {block.text}
                              {block.author && (
                                <cite className="block mt-1 text-right text-sm">
                                  — {block.author}
                                </cite>
                              )}
                            </blockquote>
                          );
                        case "subTopic":
                          return (
                            <h3 key={i} className="text-xl font-bold mt-6">
                              {block.text}
                            </h3>
                          );
                        case "table":
                          return (
                            <div key={i} className="my-6 overflow-auto">
                              <div
                                dangerouslySetInnerHTML={{ __html: block.html }}
                                className="min-w-full border rounded-md"
                              />
                            </div>
                          );

                        case "document": {
                          const url = block.url;
                          const filename = block.name || url.split("/").pop();
                          const isPDF = /\.pdf$/i.test(url);

                          return (
                            <div
                              key={i}
                              className="my-6 border p-4 rounded bg-gray-50"
                            >
                              <p className="font-medium mb-2">📎 {filename}</p>

                              {isPDF && (
                                <iframe
                                  src={url}
                                  title={filename}
                                  className="w-full h-64 border rounded mb-2"
                                />
                              )}

                              <a
                                href={url}
                                download
                                className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                              >
                                Download {filename}
                              </a>
                            </div>
                          );
                        }
                        default:
                          return null;
                      }
                    })}
                  </div>
                </>
              ) : (
                <div className="flex items-center justify-center h-40">
                  <p className="text-red-500">Error loading post</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PreViewResource;
